var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.$t(_vm.fieldName)),function(section){return _c('div',{key:section},[(_vm.isHTML(section))?_c('div',{domProps:{"innerHTML":_vm._s(_vm.getHTML(section))}}):_c('p',[_vm._v(_vm._s(section))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }